export class BingMapMarker {

  /**
   * @param {number} lat
   * @param {number} lon
   * @param {string} label marker label on pushpin
   * @param {string} title pushpin popup title
   * @param {string} description pushpin popup description
   */
  constructor(public lat: number, public lon: number, public online?: boolean, public label?: string, public title?: string, public description?: string, public url?: string) {
  }
}
